// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/icon.component.scss
// module id = 366
// module chunks = 0